<svelte:options customElement="hb-form-composer" />

<script lang="ts">
  import pkg from "../../../package.json";

  import parseStyle from "style-to-object";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";
  import type {
    Component,
    TFormSchemaGeneretor4Prop,
    Events,
  } from "./types/webcomponent.type";
  import { styleSetup as formStyleSetup } from "../form/extra/docs";
  import { styleSetup as tableStyleSetup } from "../table/extra/docs";
  import { styleSetup as dialogformStyleSetup } from "../dialogform/extra/docs";
  import type {
    Component as FormComponent,
    Events as FormEvents,
  } from "../form/types/webcomponent.type";
  import type { Events as DialogformEvents } from "../dialogform/types/webcomponent.type";
  import type {
    Component as TableComponent,
    Events as TableEvents,
  } from "../table/types/webcomponent.type";
  import { onMount } from "svelte";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "",
    // style,
    debug = false,
    output_schema = [],
  }: Component = $props();
  const schema4selector: FormComponent["schema"] = [
    {
      id: "first-row",
      type: "row",
      params: {
        columns: [
          {
            type: "text",
            placeholder: "Label...",
            id: "label",
            required: true,
            label: "Property Label",
            validationTip: "This field cannot be empty.",
          },
          {
            type: "select",
            placeholder: "Select something here...",
            id: "type",
            required: true,
            label: "Type",
            validationTip: "This field cannot be empty.",
            params: {
              options: [
                { label: "", value: "", id: "" },
                { label: "text", value: "text", id: "text" },
                { label: "textarea", value: "textarea", id: "textarea" },
                { label: "email", value: "email", id: "email" },
                { label: "number", value: "number", id: "number" },
                { label: "select", value: "select", id: "select" },
                { label: "radio", value: "radio", id: "radio" },
                { label: "checkbox", value: "checkbox", id: "checkbox" },
                { label: "file", value: "file", id: "file" },
                { label: "date", value: "date", id: "date" },
                { label: "datetime", value: "datetime", id: "datetime" },
                { label: "color", value: "color", id: "color" },
                { label: "range", value: "range", id: "range" },
              ],
            },
          },
        ],
      },
    },

    {
      id: "conditionals-row",
      type: "row",
      params: {
        columns: [
          {
            type: "checkbox",
            placeholder: "Conditional...",
            id: "conditional",
            label: "Is Conditional?",
          },
          {
            type: "checkbox",
            placeholder: "Required...",
            id: "required",
            label: "Is Required?",
          },
        ],
      },
    },

    {
      id: "size-row",
      type: "row",
      params: {
        columns: [
          {
            type: "number",
            placeholder: "Min...",
            id: "min",
            label: "Min",
            dependencies: [
              {
                id: "type",
                values: [
                  "number",
                  "date",
                  "datetime",
                  "text",
                  "textarea",
                  "range",
                ],
              },
            ],
          },
          {
            type: "number",
            placeholder: "Max...",
            id: "max",
            label: "Max",
            dependencies: [
              {
                id: "type",
                values: [
                  "number",
                  "date",
                  "datetime",
                  "text",
                  "textarea",
                  "range",
                ],
              },
            ],
          },
        ],
      },
    },
    {
      type: "arrayobjects",
      label: "conditions",
      id: "conditions",
      params: {
        addPropertyLabel: "add condition",

        schema: [
          {
            id: "conditions-row",
            type: "row",
            params: {
              columns: [
                {
                  type: "text",
                  placeholder: "Condition Property name...",
                  id: "conditionlabel",
                  required: true,
                  label: "Label",
                  validationTip: "This field cannot be empty.",
                },
                {
                  type: "text",
                  placeholder: "Condition values (separated by comma)...",
                  id: "conditionvalue",
                  label: "Values",
                  validationTip: "This field cannot be empty.",
                },
              ],
            },
          },
        ],
      },
      dependencies: [
        {
          id: "conditional",
        },
      ],
    },
    {
      type: "arrayobjects",
      label: "options",
      placeholder: "Insert your last name here...",
      id: "options",
      validationTip: "This field cannot be empty.",
      params: {
        addPropertyLabel: "add option",

        schema: [
          {
            id: "options-row",
            type: "row",
            params: {
              columns: [
                {
                  type: "text",
                  placeholder: "Property name...",
                  id: "optionlabel",
                  required: true,
                  label: "Label",
                  validationTip: "This field cannot be empty.",
                },
                {
                  type: "text",
                  placeholder: "Value...",
                  id: "optionvalue",
                  label: "Value",
                  required: true,
                  validationTip: "This field cannot be empty.",
                },
              ],
            },
          },
        ],
      },
      dependencies: [
        {
          id: "type",
          values: ["select", "radio"],
        },
      ],
    },
  ];

  let schema4selectorS: { counter: number; schema: string }[] | undefined =
    $state(undefined);

  let parsedStyle: { [x: string]: string } = $state({});
  //  let componentStyleToSet: string = "";
  let formStyleToSet: string = $state("");
  let dialogformStyleToSet: string = $state("");
  let tableStyleToSet: string = $state("");
  let formComponent: HTMLElement | undefined = $state(undefined);
  // const tableActions: TableComponent["actions"] = [
  // 	// {
  // 	// 	name: "delete",
  // 	// 	type: "icon",
  // 	// 	iconOrText: "x-octagon-fill",
  // 	// },
  // 	// {
  // 	// 	name: "edit",
  // 	// 	type: "icon",
  // 	// 	iconOrText: "pencil-square",
  // 	// },
  // ];
  const tableHeaders: TableComponent["headers"] = [
    {
      label: "Label",
      key: "label",
    },
    {
      label: "type",
      key: "type",
    },

    {
      label: "params",
      key: "params",
      nosort: true,
    },
    {
      label: "dependencies",
      key: "dependencies",
    },
    {
      label: "required",
      key: "required",
    },
    {
      label: "value",
      key: "value",
    },
    {
      label: "modifiche",
      key: "mod",
      type: "actions",
      nosort: true,
    },
  ];
  let tableRows: TableComponent["rows"] = $state([]);
  let addPropShow: boolean = $state(false);
  onMount(() => {
    addComponent({
      repoName: "@htmlbricks/hb-form",
      version: pkg.version,
    });
    addComponent({
      repoName: "@htmlbricks/hb-table",
      version: pkg.version,
    });
    addComponent({
      repoName: "@htmlbricks/hb-dialogform",
      version: pkg.version,
    });
    formComponent = $host()?.shadowRoot?.querySelector(
      "#schema",
    ) as HTMLElement;
    console.log("formComponent", formComponent);
  });
  $effect(() => {
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   formStyleToSet = getChildStyleToPass(parsedStyle, formStyleSetup?.vars);
    //   tableStyleToSet = getChildStyleToPass(parsedStyle, tableStyleSetup?.vars);
    //   dialogformStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     dialogformStyleSetup?.vars,
    //   );
    // }
    if (typeof output_schema === "string" && output_schema !== "") {
      try {
        console.log("parsing output_schema");

        output_schema = JSON.parse(output_schema);
      } catch (error) {
        console.error("error parsing output_schema", error);
      }
    }
    if (!output_schema) output_schema = [];
    if (
      typeof debug === "string" &&
      (debug === "true" || debug === "yes" || debug === "")
    )
      debug = true;
    else if (debug !== true) debug = false;
    if (!schema4selectorS)
      schema4selectorS = [
        { counter: 0, schema: JSON.stringify(schema4selector) },
      ];
    const newTableRows: TableComponent["rows"] = [];
    for (const sc of output_schema) {
      let depsString: string | undefined = undefined;
      let paramsString: string | undefined = undefined;
      if (sc.params) {
        paramsString = JSON.stringify(sc.params);
      }
      if (sc.dependencies) {
        depsString = JSON.stringify(sc.dependencies);
      }
      newTableRows.push({
        _id: sc.label,
        label: sc.label,
        type: sc.type,
        params: paramsString,
        required: sc.required,
        dependencies: depsString,
        value: sc.value,
        _actions: [
          {
            name: "delete",
            type: "icon",
            iconOrText: "x-octagon-fill",
            disabled: sc.value ? true : false,
          },
          // {
          // 	name: "edit",
          // 	type: "icon",
          // 	iconOrText: "pencil-square",
          // },
        ],
        // options: sc.options ? sc.options.map((o) => o.label).join(", ") : "",
      });
    }
    tableRows = newTableRows;
  });

  // function changeItemSchema(customEvent: any) {
  // 	console.log("changeItemSchema", customEvent);
  // 	if (customEvent._id === "type" && (customEvent.type === "select" || customEvent.value === "radio")) {
  // 		///
  // 	}
  // }

  function addSchema(e: DialogformEvents["modalFormConfirm"]) {
    console.log("addSchema", e);
    let params: {
      min?: number;
      max?: number;
      options?: { label: string; value?: String }[];
    } = {};
    let dep: { id: string; values?: string[] }[] = [];
    if (e.conditions) {
      dep = e.conditions.map(
        (c: { conditionlabel: string; conditionvalue: string }) => {
          return {
            id: c.conditionlabel,
            values: c.conditionvalue
              ? c.conditionvalue
                  .replace(", ", ",")
                  .replace(" ,", ",")
                  .split(",")
              : undefined,
          };
        },
      );
      // 	dep = {
      // 		id: e.depName,
      // 	};
      // 	if (e.depValues) dep.values = e.depValues.replace(", ", ",").replace(" ,", ",").split(",");
    }
    // const dependencies = dep ? [dep] : undefined;

    if (
      e.type === "text" ||
      e.type === "textarea" ||
      e.type === "number" ||
      e.type === "datetime" ||
      e.type === "date" ||
      e.type === "range"
    ) {
      if (e.min) params.min = e.min;
      if (e.max) params.max = e.max;
    }

    if (e.type === "select" || (e.type === "radio" && e.options?.length)) {
      params.options = [];

      for (const o of e.options as {
        optionlabel: string;
        optionvalue: string;
      }[]) {
        params.options.push({ label: o.optionlabel, value: o.optionvalue });
      }
    }

    const newFormSchema: FormComponent["schema"][0] = {
      id: e.label,
      type: e.type,
      label: e.label,
      required: e.required,
      placeholder: e.placeholder,
      dependencies: dep,
    };
    if (Object.keys(params).length) {
      newFormSchema.params = params;
    }

    if (output_schema.find((f) => f.label === e.label)) {
      // replace previous outputScheme
      output_schema = output_schema.map((f) => {
        if (f.label === e.label) {
          return newFormSchema;
        } else return f;
      });
    } else {
      // add new output_schema
      output_schema = [...output_schema, newFormSchema];
    }

    if (schema4selectorS?.length)
      schema4selectorS = [
        ...schema4selectorS,
        {
          counter: schema4selectorS.length,
          schema: JSON.stringify(schema4selector),
        },
      ];
    console.info("schema4selectorS", schema4selectorS);

    // console.log("reset form");
    // const formComponent=`<hb-form schema="${JSON.stringify(schemaSelectedString)}"`;

    // c.innerHTML=formComponent
  }
  function removeSchema(label: string) {
    console.log(label, output_schema);
    const thelabel = output_schema.find((e) => e.label === label);
    if (thelabel?.value) return console.warn("cannot remove default value");

    output_schema = output_schema.filter((e) => e.label !== label);
    if (schema4selectorS?.length) {
      schema4selectorS = schema4selectorS.filter(
        (e) => e.counter !== (schema4selectorS as any).length - 1,
      );
    }
  }
  function dispatchDone() {
    const toDispatch: Events["done"] = { schema: output_schema, id };
    dispatch("done", toDispatch);
  }
</script>

<!-- {#each output_schema as sch (sch.id)}
	<div>
		{sch.label} added

		<button
			onclick={() => {
				removeSchema(sch.id);
			}}>remove</button
		>
	</div>
{/each} -->

<hb-table
  id="table_specs"
  style={tableStyleToSet}
  disablepagination="yes"
  headers={JSON.stringify(tableHeaders)}
  rows={JSON.stringify(tableRows)}
  ontableCustomActionClick={(e: {
    detail: TableEvents["tableCustomActionClick"];
  }) => {
    if (e.detail.action === "delete") removeSchema(e.detail.itemId);
  }}
  onaddItem={(e: { detail: TableEvents["addItem"] }) => {
    addPropShow = true;
  }}
  add_item="yes"
>
  <span slot="buttons-container"
    ><button class="btn btn-outline-primary btn-sm" onclick={dispatchDone}
      >done</button
    ></span
  >
</hb-table>
{#if schema4selectorS}
  {#each schema4selectorS as sc (sc.counter)}
    {#if sc.counter === schema4selectorS.length - 1}
      <hb-dialogform
        title="Add property"
        onmodalFormConfirm={(e: {
          detail: DialogformEvents["modalFormConfirm"];
        }) => {
          console.log(e.detail);
          addSchema(e.detail);
          addPropShow = false;
        }}
        onmodalFormCancel={(e: {
          detail: DialogformEvents["modalFormCancel"];
        }) => {
          console.log("cancelform");
          addPropShow = false;
        }}
        onmodalShow={(e: { detail: DialogformEvents["modalShow"] }) => {
          console.log("modalShow");
          addPropShow = e.detail.show;
        }}
        show={addPropShow ? "yes" : "no"}
        schema={sc.schema}
        style={dialogformStyleToSet}
      ></hb-dialogform>
    {/if}
  {/each}
{/if}

{#if debug}
  <h2 style="margin:60px;text-align:center;color:blue">output</h2>
  {#if output_schema?.length}
    <hb-form
      hide_submit="yes"
      schema={JSON.stringify(output_schema)}
      style={formStyleToSet}
    ></hb-form>
  {:else}
    ...no output
  {/if}
{/if}

<style lang="scss">
  @forward "./styles/webcomponent.scss";
  @forward "./styles/bootstrap.scss";
</style>
